import { Component, OnInit } from '@angular/core';
import { ColDef, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy } from 'ag-grid-community';
import { OutingApprovalApiService } from '../outing-approval-api.service';
import { color } from 'highcharts';
import { data } from 'jquery';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { OutingApprovalDialogComponent } from '../outing-approval-dialog/outing-approval-dialog.component';

@Component({
  selector: 'app-outing-dashboard',
  templateUrl: './outing-dashboard.component.html',
  styleUrls: ['./outing-dashboard.component.scss']
})
export class OutingDashboardComponent implements OnInit {
  colDefs: ColDef<any>[] = [

    {
      field: 'reqId', headerName: 'Request Id ',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center', backgroundColor: '#0564B1', color: "#FFFFFF" },
    },
    {
      field: 'requestType', headerName: 'Request Type',
      headerStyle: { 'text-align': 'center !important', backgroundColor: '#0564B1', color: "#FFFFFF" },
    },
    {
      field: 'requestDate', headerName: 'Apply Date',
      headerStyle: { 'text-align': 'center', backgroundColor: '#0564B1', color: "#FFFFFF" },
    },
  {
      field: 'requestDescription', headerName: 'Outing Reason',
      headerStyle: { 'text-align': 'left', backgroundColor: '#0564B1', color: "#FFFFFF" },
    },
    {
      field: 'outingTime', headerName: 'Outing Time',
      headerStyle: { 'text-align': 'center', backgroundColor: '#0564B1', color: "#FFFFFF" },
    },
    {
      field: 'inTime', headerName: 'In Time',
      headerStyle: { 'text-align': 'center', backgroundColor: '#0564B1', color: "#FFFFFF" },
    },
  
    {
      field: 'requestStatus', headerName: 'Status',
      headerStyle: { 'text-align': 'center !important', backgroundColor: '#0564B1', color: "#FFFFFF" },
    },
    {
      field: 'view', headerName: 'Action',
      cellRenderer: (params: any) => {
        return `
            <svg width="29" height="29" viewBox="0 0 29 29"  class="svg" 
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path id="btn_EYE"
                                            d="M14.4961 13C16.0607 13.0002 17.3299 14.2685 17.3301 15.833C17.3301 17.3977 16.0608 18.6668 14.4961 18.667C12.9314 18.6668 11.6631 17.3977 11.6631 15.833C11.6633 14.2685 12.9315 13.0002 14.4961 13ZM14.4961 14C13.4838 14.0002 12.6633 14.8207 12.6631 15.833C12.6631 16.8454 13.4837 17.6668 14.4961 17.667C15.5085 17.6668 16.3301 16.8454 16.3301 15.833C16.3299 14.8207 15.5084 14.0002 14.4961 14ZM14.4961 10C17.3682 10 19.0143 11.4526 19.9199 12.9014C20.3673 13.6172 20.6343 14.3297 20.7891 14.8604C20.8666 15.1263 20.9161 15.3494 20.9473 15.5078C20.9628 15.5871 20.9744 15.6506 20.9814 15.6953C20.985 15.7176 20.9875 15.7353 20.9893 15.748C20.9902 15.7544 20.9907 15.7598 20.9912 15.7637C20.9915 15.7656 20.992 15.7673 20.9922 15.7686V15.7705L20 15.8955L19.999 15.8877C19.998 15.8803 19.9958 15.8681 19.9932 15.8516C19.9879 15.8182 19.9798 15.7666 19.9668 15.7002C19.9406 15.5671 19.8963 15.3733 19.8281 15.1396C19.6912 14.6704 19.4581 14.0489 19.0723 13.4316C18.3111 12.2139 16.9571 11 14.4961 11C12.0351 11 10.681 12.2139 9.91992 13.4316C9.53412 14.0489 9.30096 14.6704 9.16406 15.1396C9.09592 15.3733 9.05155 15.5671 9.02539 15.7002C9.01234 15.7666 9.00431 15.8182 8.99902 15.8516C8.99641 15.8681 8.99421 15.8803 8.99316 15.8877C8.99264 15.8914 8.99235 15.8943 8.99219 15.8955L8 15.7705V15.7686C8.00016 15.7673 8.00072 15.7656 8.00098 15.7637C8.00149 15.7598 8.00203 15.7544 8.00293 15.748C8.00473 15.7353 8.00722 15.7176 8.01074 15.6953C8.01783 15.6506 8.02934 15.5871 8.04492 15.5078C8.07604 15.3494 8.12556 15.1263 8.20312 14.8604C8.35791 14.3297 8.62487 13.6172 9.07227 12.9014C9.97785 11.4526 11.6239 10 14.4961 10Z"
                                            fill="#777777" class="color_white" />
                                    </svg>
           `;

      },
      cellStyle: { 'cursor': 'pointer', 'text-align': 'center' },
      headerStyle: { 'text-align': 'center', backgroundColor: '#0564B1', color: "#FFFFFF" },
      cellClass: ['color_white'],
      onCellClicked: (params: any) => {
        const Data = params.data;
        const target = params.event.target as HTMLElement;
        if (target.tagName.toLowerCase() === 'svg' || target.tagName.toLowerCase() === 'path') {
          const Data = params.data;
          this.openOutingApprovalDialog(Data);
        }
      }
    },
  ]


  //row intialization
  rowData: any[] = [];
  pinnedTopRowData: any[] = [];

  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    menuTabs: [],
    suppressHeaderMenuButton: true,
  };
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
      type: "fitCellContents",
    };

  quickFilter: string = '';

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }

  constructor(private outingApprovalApiService: OutingApprovalApiService, private dialog: NgDialogAnimationService) { }
  ngOnInit(): void {

    this.outingApprovalApiService.getOutingRequests("").subscribe({
      next: (res: any) => {
        console.log(res);
        this.rowData = res
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }

  openOutingApprovalDialog(data: any) {

    this.dialog.open(OutingApprovalDialogComponent, {
      width: '430px',
      height: '1100px',
      panelClass: ['animate__animated', 'animate__slideInRight'],
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      autoFocus: false,
      disableClose: false,
      hasBackdrop: true,
      data: data,
      restoreFocus: false
    })

  }


}
